module.exports = "/_next/static/images/af2366f4822899740a9e2ac76c062485-roxinho-details-metalico-xs@1x.jpg.webp";